/** @format */

import { defineStore, type StoreDefinition } from 'pinia';
import { FieldsType } from '../types';
import { useBaseConfigStoreWithOut } from '../config';
import { store } from '@/store';

interface State {
	widgetDatas: FieldsType[];
	selectField: FieldsType | null;
	formAttribute: Record<string, any>;
}

type Value<T> = {
	[K in keyof T]?: T[K];
};

const defaultValue = (name?: string) => {
	const baseConfigStore = useBaseConfigStoreWithOut(name);
	return {
		widgetDatas: [], // 表单结构数据
		selectField: null, // drge表单当前选中的数据
		formAttribute: baseConfigStore.getFormAttributeDefaultValue(), // 表单属性
	};
};

const useDragStore = (name?: string): StoreDefinition =>
	defineStore({
		id: name || 'pc-form-designer',

		state: (): State => defaultValue(),

		actions: {
			setState(obj: Value<State>) {
				for (const key in obj) {
					if (Object.prototype.hasOwnProperty.call(this, key)) {
						// @ts-ignore
						this[key] = obj[key];
					}
				}
			},

			reset() {
				this.$reset();
			},
		},
	});

export function useDragStoreWithOut(name?: string): any {
	return useDragStore(name)(store);
}
